import React from 'react';

import { TeemPersonCard } from './TeemPersonCard/TeemPersonCard';
import { teamCards } from './TeemPersonCard/teemPersonData';
import { motion } from "framer-motion";

import CodeIcon from '@mui/icons-material/Code';
import LinkIcon from '@mui/icons-material/Link';

import './TeemCard.css';

export const TeemCard: React.FC = () => {


    return (
        <> <ul className='teemCard__list'>
            {teamCards.map(({ id, titleTeam, description, work, video, linkCode,
                linkLivePage, taemList }) => (
                <li className='teemCard__item' key={id}>

                    <h2 className='teemCard__title'>Team: {titleTeam}</h2>
                    {/* список учасников */}
                    <ul className='teemCard__person-list'>
                        {taemList.map(personContent => (
                            <motion.li className='teemCard__person-item' key={personContent.id} whileHover={{ scale: [null, 1.2] }}
                                transition={{ duration: 0.3 }}>
                                <TeemPersonCard personContent={personContent} />
                            </motion.li>
                        ))}
                    </ul>

                    {/* описание проекта */}
                    <div className='teemCard__description-wrapper'>
                        <div className='teemCard__description-box'>
                            <h3>Description:</h3>
                            <br />
                            <pre id="" >
                                {description}
                            </pre>
                        </div>
                       
                        <div className='teemCard__description-img-progect-box'>
                            <iframe className='teemCard__video-progect' src={video} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                            {/* <img className='teemCard__img-progect' src={video} alt="" /> */}
                        </div>
                    </div>
                    <div className='teemCard__btn-wrapper'>
                        <ul className='teemCard__progect-icon-list'>
                            <li className='teemCard__progect-icon-item'><a href={linkCode} target="_blank" aria-label="Code" title='Code'> <CodeIcon /> </a></li>
                            <li className='teemCard__progect-icon-item' ><a href={linkLivePage} target="_blank" aria-label="Live Page" title='Live Page'> <LinkIcon /></a></li>
                        </ul>
                        {/* <motion.a href="https://t.me/the_way_of_junior" target="_blank" aria-label="Vote" title='Vote'>
                            <motion.button className='teemCard__btn' whileHover={{ scale: [null, 1.2, 1.1] }}
                                transition={{ duration: 0.3 }}>Vote for this team</motion.button>
                        </motion.a> */}
                    </div>

                </li>
            ))}


        </ul>
        </>
    )
}
